<script lang="ts">
  import {Button} from 'flowbite-svelte';
  import {cn} from 'Catalyst/cn';
  import {Icon, type IconTVProps} from 'Catalyst/components/Icon';
  import {
    buttonVariantsSizeLgIconsDensity,
    buttonVariantsSizeLgIconsSize,
    buttonVariantsSizeMdIconsDensity,
    buttonVariantsSizeMdIconsSize,
    buttonVariantsSizeSmIconsDensity,
    buttonVariantsSizeSmIconsSize,
    buttonVariantsSizeXsIconsDensity,
    buttonVariantsSizeXsIconsSize,
  } from 'Catalyst/tokens/output/button';
  import {type ButtonProps, buttonTvProps} from '.';

  // eslint-disable-next-line no-unused-vars
  type $$Props = ButtonProps;

  const iconPropsMap = {
    lg: {
      density: buttonVariantsSizeLgIconsDensity,
      size: buttonVariantsSizeLgIconsSize,
    },
    md: {
      density: buttonVariantsSizeMdIconsDensity,
      size: buttonVariantsSizeMdIconsSize,
    },
    sm: {
      density: buttonVariantsSizeSmIconsDensity,
      size: buttonVariantsSizeSmIconsSize,
    },
    xs: {
      density: buttonVariantsSizeXsIconsDensity,
      size: buttonVariantsSizeXsIconsSize,
    },
  };

  export let label: ButtonProps['label'] = 'Label';
  export let leadingIcon: ButtonProps['leadingIcon'] = '';
  export let size: ButtonProps['size'] = buttonTvProps.defaultVariants.size;
  export let style: ButtonProps['style'] = buttonTvProps.defaultVariants.style;
  export let trailingIcon: ButtonProps['trailingIcon'] = '';
  export let disabled: boolean = false;
  export let href: string = null;
  export let target: string = null;

  export let labelClass: ButtonProps['labelClass'] = {class: ''};

  const buttonTvSlots = buttonTvProps({size, style});

  const iconProps = iconPropsMap[size] as IconTVProps;

  $: klass = $$restProps.class;
</script>

<Button
  {...$$restProps}
  class={cn(buttonTvSlots.base(), klass)}
  {href}
  {target}
  on:change
  on:click
  on:keydown
  on:keyup
  on:mouseenter
  on:mouseleave
  on:touchcancel
  on:touchend
  on:touchstart
  {disabled}
>
  {#if leadingIcon}
    <Icon {...iconProps} name={leadingIcon} />
  {/if}
  <slot>
    {#if label}
      <span class={cn(buttonTvSlots.label(), labelClass.class)}>{label}</span>
    {/if}
  </slot>
  {#if trailingIcon}
    <Icon {...iconProps} name={trailingIcon} />
  {/if}
</Button>
